module.exports = __webpack_public_path__ + "img/bitcoin-btc-gold.8f7be438.svg";